const leafNametreeNode = {
  title: 'see equipment'
};

export default leafNametreeNode;
